import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import ImageControl from "../../common/ImageControl";
import Text from "../../common/Text";
import {
  doFirstUpperRestLower,
  makeSalaryString,
  websiteLink,
} from "../../../helpers/helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckSquare,
  faSquare,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import {
  saveAppliedJobStat,
  markAsApplied,
  deleteJob,
} from "../../../states/actions/fetchDashboard";
import { useSelector, useDispatch } from "react-redux";
import { jobProgressColor } from "../../../helpers/helpers";
import * as paths from "../../../constants/paths";

const JobsEventsNew = ({ jobs, applied_job_actions, jobsType, content }) => {
  const dispatch = useDispatch();
  const [openTooltip, setOpenTooltip] = useState({ jobId: null, type: null });

  const tooltipRefs = useRef({});
  useEffect(() => {
    const handleClickOutside = (e) => {
      const openId = openTooltip?.jobId;
      if (
        openId &&
        tooltipRefs.current[openId] &&
        !tooltipRefs.current[openId].contains(e.target)
      ) {
        setOpenTooltip({ jobId: null, type: null });
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openTooltip]);

  // const toggle = (type) => setOpen(open === type ? null : type);
  const toggle = (jobId, type) => {
    setOpenTooltip((prev) =>
      prev.jobId === jobId && prev.type === type
        ? { jobId: null, type: null }
        : { jobId, type }
    );
  };

  const tooltip =
    "A job is labelled as ‘definitely sponsor' if the job description clearly states that the role is eligible for visa sponsorship or if the company has a policy of sponsoring visas for all its roles.";

  const isAppliedJobStatUpdating = useSelector(
    (state) => state.fetchDashboard.isAppliedJobStatUpdating
  );
  const isMarkAsAppliedProcessing = useSelector(
    (state) => state.fetchDashboard.isMarkAsAppliedProcessing
  );
  const isJobDeleting = useSelector(
    (state) => state.fetchDashboard.isJobDeleting
  );

  const handleSaveJobStat = (e, id) => {
    dispatch(saveAppliedJobStat({ action: e.target.value, id }));
  };

  const handleMarkAsApplied = (id) => {
    dispatch(markAsApplied({ id }));
  };

  const handleDeleteJob = (formData) => {
    dispatch(deleteJob(formData));
  };

  return (
    <>
      <div className="job_outer mt-5">
        {!jobs.length ? (
          <>
            {jobsType == 1 ? (
              <div className="no_data_found">
                <div className="icon_img">
                  <img
                    src={paths.SITE_BASE_URL + "/images/n-dashboard/job-6.svg"}
                    alt="doucment image"
                  />
                </div>
                <div className="inner_cntnt">
                  <p>
                    <strong>No jobs applied yet</strong>
                  </p>
                  <p>
                    You haven't applied for any jobs. Start your job search
                    journey today!
                  </p>
                  <div className="btn_blk text-center">
                    <Link to={websiteLink("/open-jobs/1")} className="site_btn">
                      Browse Open Positions
                    </Link>
                  </div>
                </div>
              </div>
            ) : jobsType == 2 ? (
              <div className="no_data_found">
                <div className="icon_img">
                  <img
                    src={paths.SITE_BASE_URL + "/images/n-dashboard/job-6.svg"}
                    alt="doucment image"
                  />
                </div>
                <div className="inner_cntnt">
                  <p>
                    <strong>No jobs saved yet</strong>
                  </p>
                  <p>The jobs that you have saved will show here</p>
                  <div className="btn_blk text-center">
                    <Link to={websiteLink("/open-jobs/1")} className="site_btn">
                      Browse Open Positions
                    </Link>
                  </div>
                </div>
              </div>
            ) : jobsType == 3 ? (
              <div className="no_data_found">
                <div className="icon_img">
                  <img
                    src={paths.SITE_BASE_URL + "/images/n-dashboard/job-6.svg"}
                    alt="doucment image"
                  />
                </div>
                <div className="inner_cntnt">
                  <p>
                    <strong>No jobs in the Interviewing stage yet</strong>
                  </p>
                  <p>
                    Jobs marked as “Online Test Completed” , "Interviewing" or
                    "Assessment Day Completed" will appear here.
                  </p>
                </div>
              </div>
            ) : jobsType == 4 ? (
              <div className="no_data_found">
                <div className="icon_img">
                  <img
                    src={paths.SITE_BASE_URL + "/images/n-dashboard/job-6.svg"}
                    alt="doucment image"
                  />
                </div>
                <div className="inner_cntnt">
                  <p>
                    <strong>No Job Offers Received Yet</strong>
                  </p>
                  <p>Jobs marked as "Offer Received" will appear here</p>
                </div>
              </div>
            ) : jobsType == 5 ? (
              <div className="no_data_found">
                <div className="icon_img">
                  <img
                    src={paths.SITE_BASE_URL + "/images/n-dashboard/job-6.svg"}
                    alt="doucment image"
                  />
                </div>
                <div className="inner_cntnt">
                  <p>
                    <strong>No Rejected Jobs Yet</strong>
                  </p>
                  <p>Jobs marked as "Failed" will appear here</p>
                </div>
              </div>
            ) : null}
          </>
        ) : (
          jobs.map((job) => (
            <div
              className="job_inner"
              key={job.id}
              ref={(el) => (tooltipRefs.current[job.id] = el)}
            >
              <div className="flex">
                <a href="#!" className="img_icon">
                  {job.image == "" || job.image == null ? (
                    <img
                      src={paths.SITE_BASE_URL + "/images/no-image.svg"}
                      alt="no image found"
                    />
                  ) : (
                    <ImageControl
                      src={job.image}
                      folder="companies"
                      isThumb={true}
                    />
                  )}
                </a>
                <div className="cntnt">
                  <h5>
                    {job.is_internal_or_external === "external" ? (
                      <a href={job.job_link} target="_blank">
                        <Text string={job.title} />
                      </a>
                    ) : (
                      <Link to={`/job-profile/${job.id}`}>
                        <Text string={job.title} />
                      </Link>
                    )}
                  </h5>
                  <div className="company company_1 tooltip-wrapper">
                    <a
                      href="javascript:void(0)"
                      onClick={(e) => {
                        e.preventDefault();
                        toggle(job.id, "company");
                      }}
                    >
                      <Text string={job.company_name} />
                      <div className="info_icon">
                        <img
                          src={paths.SITE_BASE_URL + "/images/info.png"}
                          alt=""
                        />
                      </div>
                    </a>

                    {openTooltip.jobId === job.id &&
                      openTooltip.type === "company" && (
                        <div
                          className="globals"
                          ref={(el) => (tooltipRefs.current[job.id] = el)}
                        >
                          <p className="globals_info">
                            Based on Home Office data , {job.company_name}{" "}
                            sponsored {job.computed_cos_total ?? 0} people in
                            2025.{" "}
                            {/* This company sponsored {job.computed_cos_total ?? 0}{" "}
                            people in 2025 based on Home Office data{" "} */}
                          </p>
                        </div>
                      )}
                  </div>

                  {/* <p>
                    <Text string={job.company_name} />
                  </p> */}
                  <div className="tages_u tooltip-wrapper-flex">
                    {job.is_promoted === "1" && (
                      <div className={`tooltip-wrapper ${openTooltip.type === "promoted" && "open"}`}>
                        <span
                          // href="#!"
                          className="featured_job_new"
                          // onClick={(e) => {
                          //   e.preventDefault();
                          //   toggle(job.id, "promoted");
                          // }}
                        >
                          {content.is_promoted_label}
                        </span>
                        {openTooltip.jobId === job.id &&
                          openTooltip.type === "promoted" && (
                            <div className="globals">
                              <p className="globals_info">
                                {content.is_promoted_desc}
                              </p>
                            </div>
                          )}
                      </div>
                    )}

                    {/* <a class="featured_job_new" href="/open-jobs/1">
                      Promoted
                    </a> */}
                    {job.likely_to_sponsor === "yes" && (
                      <div className={`tooltip-wrapper ${openTooltip.type === "likely" && "open"}`}>
                        <a
                          href="#!"
                          className="featured_job_new3"
                          onClick={(e) => {
                            e.preventDefault();
                            toggle(job.id, "likely");
                          }}
                        >
                          {content.likely_sponsor_label}
                        </a>
                        {openTooltip.jobId === job.id &&
                          openTooltip.type === "likely" && (
                            <div className="globals">
                              <p className="globals_info">
                                {content.likely_sponsor_desc}
                              </p>
                            </div>
                          )}
                      </div>
                    )}

                    {/* <a class="featured_job_new2" href="/open-jobs/1">
                      Likely to sponsor
                    </a> */}

                    {job.definitely_sponsored === "yes" && (
                      <div className={`tooltip-wrapper ${openTooltip.type === "definitely" && "open"}`}>
                        <a
                          href="#!"
                          className="featured_job_new2"
                          onClick={(e) => {
                            e.preventDefault();
                            toggle(job.id, "definitely");
                          }}
                        >
                          {content.definitely_sponsor_label}
                        </a>
                        {openTooltip.jobId === job.id &&
                          openTooltip.type === "definitely" && (
                            <div className="globals">
                              <p className="globals_info">
                                {content.definitely_sponsor_desc}
                              </p>
                            </div>
                          )}
                      </div>
                    )}

                    {job.new_entrant === "yes" && (
                      <div className={`tooltip-wrapper ${openTooltip.type === "new" && "open"}`}>
                        <a
                          href="#!"
                          className="featured_job_new4"
                          onClick={(e) => {
                            e.preventDefault();
                            toggle(job.id, "new");
                          }}
                        >
                          {content.new_entry_label}
                        </a>
                        {openTooltip.jobId === job.id &&
                          openTooltip.type === "new" && (
                            <div className="globals">
                              <p className="globals_info">
                                {content.new_entry_desc}
                              </p>
                            </div>
                          )}
                      </div>
                    )}

                    {job.student_graduate === "yes" && (
                      <div className={`tooltip-wrapper ${openTooltip.type === "student" && "open"}`}>
                        <a
                          href="#!"
                          className="featured_job_new5"
                          onClick={(e) => {
                            e.preventDefault();
                            toggle(job.id, "student");
                          }}
                        >
                          {content.student_label}
                        </a>
                        {openTooltip.jobId === job.id &&
                          openTooltip.type === "student" && (
                            <div className="globals">
                              <p className="globals_info">
                                {content.student_desc}
                              </p>
                            </div>
                          )}
                      </div>
                    )}

                    {/* <a class="featured_job_new3" href="/open-jobs/1">
                      Definitely sponsor
                    </a> */}
                  </div>
                  <ul className="specific_info">
                    <li>
                      <img
                        src={paths.SITE_BASE_URL + "/images/new/location.svg"}
                        alt=""
                      />
                      <span>
                        <Text string={job.city} />
                      </span>
                    </li>
                    <li>
                      <img
                        src={paths.SITE_BASE_URL + "/images/new/teacher.svg"}
                        alt=""
                      />
                      <span>
                        <Text
                          string={`${
                            job.degree_requirement == "no-minimum"
                              ? "No Minimum"
                              : job.degree_requirement
                          }`}
                        />
                      </span>
                    </li>
                    <li>
                      <img
                        className="sm_icon_pound"
                        src="images/pound1.png"
                        alt=""
                      />
                      <span>
                        {makeSalaryString(
                          job.min_salary,
                          job.max_salary,
                          job.salary_interval
                            ? doFirstUpperRestLower(job.salary_interval)
                            : "Not Specified"
                        )}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="dash_action">
                {jobsType === 1 ? (
                  <>
                    <div className="del_action">
                      <button
                        onClick={() =>
                          handleDeleteJob({
                            id: job.encoded_id,
                            from: "applied",
                          })
                        }
                        disabled={isJobDeleting}
                      >
                        Delete
                      </button>
                    </div>
                    <select
                      value={job.job_status}
                      onChange={(e) => handleSaveJobStat(e, job.encoded_id)}
                      disabled={isAppliedJobStatUpdating}
                      className={
                        "status_drop " +
                        jobProgressColor(job.job_status) +
                        "_drop"
                      }
                    >
                      {applied_job_actions &&
                        applied_job_actions.map((row) => (
                          <option key={row.key} value={row.key}>
                            {row.value}
                          </option>
                        ))}
                    </select>
                  </>
                ) : jobsType === 2 ? (
                  <>
                    <div className="del_action">
                      <button
                        onClick={() =>
                          handleDeleteJob({
                            id: job.encoded_id,
                            from: "saved",
                          })
                        }
                        disabled={isJobDeleting}
                      >
                        Delete
                      </button>
                    </div>
                    <button
                      className="mark_complete_lbl"
                      onClick={() => handleMarkAsApplied(job.encoded_id)}
                      disabled={isMarkAsAppliedProcessing}
                    >
                      Mark As Applied
                      <FontAwesomeIcon icon={faCheckSquare} />
                    </button>
                  </>
                ) : jobsType === 3 ? (
                  <>
                    <div className="del_action">
                      <button
                        onClick={() =>
                          handleDeleteJob({
                            id: job.encoded_id,
                            from: "interviewing",
                          })
                        }
                        disabled={isJobDeleting}
                      >
                        Delete
                      </button>
                    </div>
                    <select
                      value={job.action}
                      onChange={(e) => handleSaveJobStat(e, job.encoded_id)}
                      disabled={isAppliedJobStatUpdating}
                      className={
                        "status_drop " + jobProgressColor(job.action) + "_drop"
                      }
                    >
                      {applied_job_actions &&
                        applied_job_actions.map((row) => (
                          <option key={row.key} value={row.key}>
                            {row.value}
                          </option>
                        ))}
                    </select>
                  </>
                ) : jobsType === 4 ? (
                  <>
                    <div className="del_action">
                      <button
                        onClick={() =>
                          handleDeleteJob({
                            id: job.encoded_id,
                            from: "job_offers",
                          })
                        }
                        disabled={isJobDeleting}
                      >
                        Delete
                      </button>
                    </div>
                    <select
                      value={job.action}
                      onChange={(e) => handleSaveJobStat(e, job.encoded_id)}
                      disabled={isAppliedJobStatUpdating}
                      className={
                        "status_drop " + jobProgressColor(job.action) + "_drop"
                      }
                    >
                      {applied_job_actions &&
                        applied_job_actions.map((row) => (
                          <option key={row.key} value={row.key}>
                            {row.value}
                          </option>
                        ))}
                    </select>
                  </>
                ) : jobsType === 5 ? (
                  <>
                    <div className="del_action">
                      <button
                        onClick={() =>
                          handleDeleteJob({
                            id: job.encoded_id,
                            from: "rejection",
                          })
                        }
                        disabled={isJobDeleting}
                      >
                        Delete
                      </button>
                    </div>
                    <select
                      value={job.action}
                      onChange={(e) => handleSaveJobStat(e, job.encoded_id)}
                      disabled={isAppliedJobStatUpdating}
                      className={
                        "status_drop " + jobProgressColor(job.action) + "_drop"
                      }
                    >
                      {applied_job_actions &&
                        applied_job_actions.map((row) => (
                          <option key={row.key} value={row.key}>
                            {row.value}
                          </option>
                        ))}
                    </select>
                  </>
                ) : null}
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default JobsEventsNew;
